/* eslint-disable no-underscore-dangle */
import type {
  PostLeadRCMBody,
  SendContactWithPrescreenToAgentError,
  SendContactWithPrescreenToAgentRequestPayload,
  SendContactWithPrescreenToAgentResponse,
  SendEmailToAgentError,
  SendEmailToAgentRequestPayload,
  SendEmailToAgentResponse,
  SendScheduleTourRequestToAgentRequestPayload,
  SendScheduleTourRequestToAgentResponse,
  SendScheduleTourRequestToAgentError,
} from './types'
import type { AxiosResponse } from 'axios'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { publicMessagingApiInstance, messagingApiInstance } from 'api'

import { authService } from '../../auth'

import { NAME } from './constant'
import { sendRCMWithOutActivities } from './utils'

export const sendEmailToAgent = createAsyncThunk(
  `${NAME}/SEND_EMAIL_TO_AGENT`,
  async (data: SendEmailToAgentRequestPayload, { rejectWithValue }) => {
    const { sender, recipient, message, source, property } = data
    const postLeadRCMBody: PostLeadRCMBody = {
      email: sender.email,
      owner_id: recipient?._id,
      firstName: sender.fullName,
      mobileNumber: sender.phone,
      source,
      automated: true,
    }
    try {
      const response: AxiosResponse<SendEmailToAgentResponse> =
        await publicMessagingApiInstance.put('/conversations/send-email', {
          sender,
          recipient,
          message,
          source,
          property,
        })
      sendRCMWithOutActivities({ postLeadRCMBody, property }).catch(() => true)
      return response
    } catch (e: unknown) {
      const error = e as AxiosResponse<SendEmailToAgentError>
      if (!error?.data) {
        throw e
      }
      return rejectWithValue(error.data)
    }
  },
)

export const sendContactWithPrescreenToAgent = createAsyncThunk(
  `${NAME}/SEND_CONTACT_WITH_PRESCREEN_TO_AGENT`,
  async (data: SendContactWithPrescreenToAgentRequestPayload, { rejectWithValue }) => {
    const { sender, recipient, messages, source, property, turnstileToken, turnstile } = data
    const email = await authService.getEmail()

    const postLeadRCMBody: PostLeadRCMBody = {
      email,
      firstName: sender.fullName,
      owner_id: recipient?._id,
      source,
      automated: true,
    }
    try {
      const response: AxiosResponse<SendContactWithPrescreenToAgentResponse> =
        await messagingApiInstance.put('/conversations/send-message-with-email', {
          recipient,
          messages,
          source,
          turnstileToken,
          property,
        })
      sendRCMWithOutActivities({ postLeadRCMBody, property }).catch(() => true)
      return response
    } catch (e: unknown) {
      const error = e as AxiosResponse<SendContactWithPrescreenToAgentError>
      if (!error?.data) {
        throw e
      }
      return rejectWithValue(error.data)
    } finally {
      if (turnstile) {
        turnstile.reset()
      }
    }
  },
)

export const sendScheduleTourRequestToAgent = createAsyncThunk(
  `${NAME}/SEND_SCHEDULE_TOUR_REQUEST_TO_AGENT`,
  async (data: SendScheduleTourRequestToAgentRequestPayload, { rejectWithValue }) => {
    const { sender, recipient, messages, source, property, turnstileToken, turnstile } = data

    const email = await authService.getEmail()

    const postLeadRCMBody: PostLeadRCMBody = {
      email,
      owner_id: recipient?._id,
      firstName: sender.fullName,
      source,
      automated: true,
    }
    try {
      const response: AxiosResponse<SendScheduleTourRequestToAgentResponse> =
        await messagingApiInstance.put('/conversations/send-message-with-email', {
          recipient,
          messages,
          source,
          turnstileToken,
          property,
        })
      sendRCMWithOutActivities({ postLeadRCMBody, property }).catch(() => true)
      return response
    } catch (e: unknown) {
      const error = e as AxiosResponse<SendScheduleTourRequestToAgentError>
      if (!error?.data) {
        throw e
      }
      return rejectWithValue(error.data)
    } finally {
      if (turnstile) {
        turnstile.reset()
      }
    }
  },
)

export const asyncActions = {
  sendEmailToAgent,
  sendContactWithPrescreenToAgent,
  sendScheduleTourRequestToAgent,
}
